// Shared validation for the check serve window rules setting. Kept free of any control or
// property import so both the control and the validation pipeline can use it.
export class CheckServeWindowRulesHelper {
  public static readonly MinutesMin = 1;
  public static readonly MinutesMax = 1440;

  public static readonly AnchorOpen = 'Open';
  public static readonly AnchorClose = 'Close';

  public static get anchorOptions() {
    return [
      { label: this.AnchorOpen, value: this.AnchorOpen },
      { label: this.AnchorClose, value: this.AnchorClose },
    ];
  }

  // one anchor per order type, so this pair is what has to stay unique.
  // empty when either half is missing, because an incomplete row is caught by the field checks
  public static ruleKey(orderType, anchor): string {
    const type = (orderType || '').toString().trim().toLowerCase();
    const anch = (anchor || '').toString().trim().toLowerCase();

    if (!type || !anch) return '';

    return `${type}|${anch}`;
  }

  public static isAnchorValid(anchor): boolean {
    const value = (anchor || '').toString().trim();
    return value == this.AnchorOpen || value == this.AnchorClose;
  }

  public static areMinutesValid(minutes): boolean {
    if (minutes == null || minutes === '') return false;

    const value = Number(minutes);

    return (
      !isNaN(value) &&
      value % 1 == 0 &&
      value >= this.MinutesMin &&
      value <= this.MinutesMax
    );
  }

  // an empty rule set is valid - it simply means no rules are configured
  public static isValid(rules): boolean {
    if (!rules || !rules.length) return true;

    const keys = [];

    for (const rule of rules) {
      if (!rule) return false;

      if (!(rule.orderType || '').toString().trim()) return false;
      if (!this.isAnchorValid(rule.anchor)) return false;
      if (!this.areMinutesValid(rule.minutes)) return false;

      const key = this.ruleKey(rule.orderType, rule.anchor);
      if (keys.indexOf(key) >= 0) return false;

      keys.push(key);
    }

    return true;
  }
}
